import { format } from 'date-fns';

export default function formatSopEop(date) {
  if (!date) return 'no data available';
  return format(new Date(date), 'yyyy-MM-dd');
}
